import React from "react";
import "./../../../style.scss";
import { TableHead, TableRow, TableCell, withStyles } from "@material-ui/core";
import styles from "./styles";
import { getPriorityPickupIcon } from "../../../../../modules/Dispatch/RouteExecution/utils/pickupIcon";
import MapPopupTooltip from "../MapPopupTooltip";
import CustomerMergeIndicator from "../../../../../common/CustomerMergeIndicator";

const Header = ({
  name,
  address,
  stopSequence,
  classes,
  isDelayStop = false,
  Marker,
  markerProps={},
  pickupPriority="",
  themeColors={},
  customerName,
  mergeIconColor
}) => {
  return (
    <TableHead className={isDelayStop ? classes.tableHeadDelayStop : classes.tableHead}>
      <TableRow className={classes.tableHeadHeight}>
        <TableCell colSpan={2}>
          <div className={classes.headerContainer}>
            <span
              className={`${classes.pickupMarker} ${
                pickupPriority ? classes.pickupMarkerHeight : ''
              }`}>
              <Marker stopNo={stopSequence} {...markerProps} {...themeColors} />
              {pickupPriority ? (
                <MapPopupTooltip title={pickupPriority}>
                  {getPriorityPickupIcon({ className: classes.pickupPriority })}
                </MapPopupTooltip>
              ) : null}
            </span>
            <span className={classes.tableHeaderCell}>
              <div className={`${classes.nameContainer} ${customerName ? classes.mergeNameWrap : ""}`}>
                <MapPopupTooltip title={name}>
                  <span className={`${classes.name} ${ classes.maxWidth}`}>{name}</span>
                </MapPopupTooltip>
                <CustomerMergeIndicator
                  displayCustomerName={name}
                  customerName={customerName}
                  color={mergeIconColor}
                />
              </div>
              <MapPopupTooltip title={address}>
                <div className={classes.address}>{address}</div>
              </MapPopupTooltip>
            </span>
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default withStyles(styles)(Header);
